angular.module('blc').factory('browser', browser);
browser.$inject = ['$q', '$log', '$http'];
function browser($q, $log, $http) {
  var promise = $http.get('/client-data');
  return {
    getData: promise
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/browser_info.js
 ** module id = 15
 ** module chunks = 0
 **/